// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section4 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section four' style={{colorScheme: this.props.colorMode === 'dark' ? 'dark' : 'light'}}>
      <div className="wrapper">
        <h2>So alt werden Hunde</h2>
          <div className='txt'>
            <p>
              Daten zum Alter von verstorbenen Hunden sind leider nicht öffentlich zugänglich. Aber es ist allgemein bekannt, dass die Tiere im Schnitt etwa 10 bis 15 Jahre alt werden. Grosse Exemplare haben eine deutlich geringere Lebenserwartung als kleine – vielleicht ein weiterer Grund, warum Letztere bevorzugt werden.
            </p>
            <p>
              In der Schweiz sind zurzeit nur 4 Prozent der Hunde über 15-jährig. Die meisten sind 1- bis 3-jährig. In Menschenleben entspricht das aber schon ungefähr 29 Jahren. Ab 10 Hundejahren nimmt die Zahl der Tiere stark ab. Nur ein Viertel ist älter. Ein 10-jähriger Hund wäre als Mensch schon um die 60 Jahre alt. 
            </p>
          </div>
          <div className="chart">
            <AutofitIFrame
              src={'https://datawrapper.dwcdn.net/CXZc2/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
            />
          </div>        
          <div className='txt'>
            <p>
              Die Lebenserwartung von Hunden wird nicht nur von der Grösse respektive der Rasse bestimmt, sondern auch von den Lebensumständen: der Ernährung und Pflege, dem Umfeld und der Menge an Bewegung. So leben Landhunde meistens etwas länger als ihre Artgenossen in der Stadt.
            </p>
          </div>
      </div>
    </div>
  }
}
